import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ReportsService } from 'src/app/services/reports.service';
import { PdfViewerComponent } from '../pdf-viewer/pdf-viewer.component';

@Component({
    selector: 'app-common-pdf',
    templateUrl: './common-pdf.component.html',
    styleUrls: ['./common-pdf.component.scss'],
    standalone: false
})
export class CommonPdfComponent implements OnInit {

  constructor(protected dialog:MatDialog) { }

  ngOnInit(): void {
  }

  openReport(reportData,dialogData){
    
     
      this.dialog.open(PdfViewerComponent, {
        width: '100%',
        maxWidth: '90%',
        height: 'auto',
        data: {
          title: dialogData.title,
          srcType: 'Binary',
          pdfData: new Blob([reportData], { type: 'application/pdf' }),
          downloadFileName: dialogData.downloadFileName,
          downLoadFile:true
        }
      });
   
   
    }

}
